module.exports = __webpack_public_path__ + "u13.no2.7e101e32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u13.no2.jpg
// module id = K4NX
// module chunks = 0